export const INSURANCE_CONSIDERATION_TYPES = Object.freeze({
  DRAFT: 'draft',
  DEFAULT: 'default',
  WITH_INSURANCE: 'with_insurance',
  WITHOUT_INSURANCE: 'without_insurance',
});

export const INSURANCE_PROVIDERS = {
  A_PLUS: 'a_plus',
  DORDOI: 'dordoi',
};
